<style scoped>
main {
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.welcome-scroll {
	flex: 1 1 auto;
	min-height: 0;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
}
.welcome-logo {
	width: 150px;
	height: 150px;
	object-fit: contain;
	margin: 0 auto;
}
.welcome-title {
	font-size: 2rem;
	font-weight: 600;
}
</style>
<template>
	<main>
		<div class="welcome-scroll">
			<img
				v-if="showLogo"
				:src="logoUrl"
				:alt="org.name"
				class="welcome-logo mb-3"
				@error="logoError = true"
			/>
			<h2 class="welcome-title mb-3">
				{{ t("welcome_title", { district_name: org.name }) }}
			</h2>

			<div class="alert alert-light border text-start py-3">
				<p class="mb-0 fs-5">{{ t("welcome_body") }}</p>
			</div>

			<div v-if="started" class="alert alert-primary" role="alert">
				<i class="bi bi-info-circle me-1"></i>{{ t("resume_note") }}
			</div>
		</div>

		<div class="d-grid mt-2">
			<button type="button" class="btn btn-primary btn-lg" @click="doStart">
				{{ t("start") }}
			</button>
		</div>
	</main>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import { useOrg, useT } from "@/rmo/content/mosquito/copy";
import { router } from "@/rmo/route/config";
import { useRoutes } from "@/rmo/route/use";
import { useStoreVirtualInspection } from "@/rmo/store/virtualinspection";

interface Props {
	token: string;
}

const props = defineProps<Props>();
const routes = useRoutes();
const store = useStoreVirtualInspection();
const t = useT();
const org = computed(useOrg);
const logoError = ref(false);
const logoUrl = computed(() => store.state?.logo_url ?? "");
const showLogo = computed(() => !!logoUrl.value && !logoError.value);

const started = computed(() => (store.state?.observations.length ?? 0) > 0);

function doStart() {
	router.push(routes.MosquitoCheckWalk(props.token));
}
</script>
